import CustomToast from "../components/UI/customToast";
import { setIsCallDisconnected } from "../reducers/common-reducer";
import { JOIN_MEETING_EVENTS, JOIN_MEETING, SEND_DEVICE_INFORMATION } from "../reducers/joinMeeting-reducer";
import joinMeetingService from "../services/joinMeetingService";
//#region Join meeting
const joinMeetingStart = () => {
    return {
        event: JOIN_MEETING_EVENTS.JOIN_MEETING,
        type: JOIN_MEETING.START,
    };
};

const joinMeetingSuccess = (data) => {
    return {
        event: JOIN_MEETING_EVENTS.JOIN_MEETING,
        type: JOIN_MEETING.SUCCESS,
        payload: data,
    };
};

const joinMeetingError = (error) => {
    return {
        event: JOIN_MEETING_EVENTS.JOIN_MEETING,
        type: JOIN_MEETING.ERROR,
        payload: error,
    };
};

export const handleJoinMeetingAPI = (req) => async (dispatch) => {
    dispatch(joinMeetingStart());
    joinMeetingService
        .joinMeetingServiceFunction(req)
        .then((response) => {
            dispatch(setIsCallDisconnected(false)); // for reconnect waiting screen issue resolve
            dispatch(joinMeetingSuccess(response));
        })
        .catch((error) => {
            CustomToast.error(error);
            dispatch(joinMeetingError(error));
        });
};

//#endregion Join meeting

//#region send user device information
const sendUserDeviceInformationStart = () => {
    return {
        event: JOIN_MEETING_EVENTS.SEND_DEVICE_INFORMATION,
        type: SEND_DEVICE_INFORMATION.START,
    };
};

const sendUserDeviceInformationSuccess = (data) => {
    return {
        event: JOIN_MEETING_EVENTS.SEND_DEVICE_INFORMATION,
        type: SEND_DEVICE_INFORMATION.SUCCESS,
        payload: data,
    };
};

const sendUserDeviceInformationError = (error) => {
    return {
        event: JOIN_MEETING_EVENTS.SEND_DEVICE_INFORMATION,
        type: SEND_DEVICE_INFORMATION.ERROR,
        payload: error,
    };
};

export const sendUserDeviceInformation = (req) => async (dispatch) => {
    dispatch(sendUserDeviceInformationStart());
    joinMeetingService
        .sendDeviceInformationService(req)
        .then((response) => {
            dispatch(sendUserDeviceInformationSuccess(response));
        })
        .catch((error) => {
            CustomToast.error(error);
            dispatch(sendUserDeviceInformationError(error));
        });
};

//#endregion send user device information

//#endregion remove duplicate agent (old agent)
export const resetJoinCallReducer = () => async (dispatch) => {
    dispatch({ event: JOIN_MEETING_EVENTS.RESET_JOIN_MEETING, type: "" });
};
